export const GOOGLE_API_KEY = 'AIzaSyBHK4QeuEk8smdq4CQlpdDilsTxBtlwpNI';
export const phoneNumberPrefix = '+91';

export const USER_LOCATION_HOME = 'Home';
export const USER_LOCATION_WORK = 'Work';
export const USER_LOCATION_OTHER = 'Other';

export const TOKEN_EXPIRED = 'expired';

export const cartWarningMessage = 'If you want to purchase from other category shops, you must check out the current cart items or ' +
    'would like to clear the cart?';
